import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { cloneDeep, isEmpty } from 'lodash';
import clsx from 'clsx';

import Chip from '@material-ui/core/Chip';
import AutoComplete from '@material-ui/lab/Autocomplete';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import * as classes from './ConfigurePanel.module.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ConfigurePanel = ({
    bobLoading,
    entityRules,
    entityRulesMeta,
    entitySensors,
    selectedEquipment,
    selectedSystems,
    selectedSpaceAirSensors,
    selectedOutsideAirSensors,
    selectedRules,
    selectedState,
    selectedStateItems,
    setSelectedState,
    setSelectedStateItems,
    setSelectedRules,
    setSelectedOutsideAirSensors,
    setSelectedSpaceAirSensors,
    spaceAirSensorData,
    outsideAirSensorData,
    ...props
}) => {
    const [spaceAirSensors, setSpaceAirSensors] = useState([]);
    const [outsideAirSensors, setOutsideAirSensors] = useState([]);

    useEffect(() => {
        if (!isEmpty(entitySensors)) {
            const spaceAir = cloneDeep(entitySensors.spaceAirSensors);
            const outsideAir = cloneDeep(entitySensors.outsideAirSensors);
            if (!isEmpty(spaceAir)) {
                spaceAir.unshift({ sensorid: 0, sensorName: 'All', itemName: 'All' });
            }
            if (!isEmpty(outsideAir)) {
                outsideAir.unshift({ sensorid: 0, sensorName: 'All', itemName: 'All' });
            }
            setSpaceAirSensors(spaceAir);
            setOutsideAirSensors(outsideAir);
        }
    }, [entitySensors]);

    const handleChangeSpaceAirSensors = (event, value) => {
        if (event.target.textContent === 'All' || event.target.value === '0') {
            setSelectedSpaceAirSensors(spaceAirSensors);
        }
        else {
            let updatedValues = [...value];
            updatedValues = updatedValues.filter(item => item.sensorid !== 0);
            setSelectedSpaceAirSensors(updatedValues);
        }
    };

    const handleChangeOutsideAirSensors = (event, value) => {
        if (event.target.textContent === 'All' || event.target.value === '0') {
            setSelectedOutsideAirSensors(outsideAirSensors);
        }
        else {
            let updatedValues = [...value];
            updatedValues = updatedValues.filter(item => item.sensorid !== 0);
            setSelectedOutsideAirSensors(updatedValues);
        }        
    };

    const renderCheckboxLabel = option => {
        if (option.sensorid === 0) {
            return 'All';
        }
        else {
            return `${option.itemName} - ${option.sensorName}`;
        }
    };

    return (
        <div>
            {
                (isEmpty(selectedSystems) && isEmpty(selectedEquipment)) || isEmpty(entitySensors) ?
                    <div className={classes.NoSelectedEntity}>
                        <span className={clsx('material-icons-outlined md-18', classes.Icon)}>
                            info
                        </span>
                        <span className={classes.Text}>Select 'Equipment' and/or 'System' to view sensors.</span>
                    </div>
                    :
                    <div>
                        <FormControl className={classes.InputWrapper}>
                            <AutoComplete
                                id="spaceAirSensors"
                                name="spaceAirSensors"
                                multiple
                                disableCloseOnSelect
                                disabled={false}
                                options={spaceAirSensors}
                                getOptionLabel={(option) => option.sensorName || ''}
                                getOptionSelected={(option, value) => option && value ? option.sensorid === value.sensorid : ''}
                                value={selectedSpaceAirSensors}
                                onChange={(event, value) => handleChangeSpaceAirSensors(event, value)}
                                size="small"
                                renderTags={(value, getTagProps) => value.map((option, index) => {
                                    if (index < 2) {
                                        return (
                                            <Chip
                                                classes={{
                                                    root: classes.Chip
                                                }}
                                                variant="outlined"
                                                label={option.sensorName}
                                                {...getTagProps({ index })}
                                            />
                                        );
                                    } else if (index === 2) {
                                        return (<span className={classes.Tag}>{` + ${value.length - 2} Selected`}</span>);
                                    } else {
                                        return null;
                                    }
                                })}
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                        <Checkbox
                                            value={option.sensorid}
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {renderCheckboxLabel(option)}
                                    </React.Fragment>
                                )}
                                required
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        className={classes.Required}
                                        label="Space Air Sensors"
                                        variant="outlined"
                                        error={Boolean(spaceAirSensorData)}
                                        helperText={spaceAirSensorData}
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />}
                            />
                        </FormControl>
                        <FormControl className={classes.InputWrapper}>
                            <AutoComplete
                                id="outsideAirSensors"
                                name="outsideAirSensors"
                                multiple
                                disableCloseOnSelect
                                disabled={false}
                                options={outsideAirSensors}
                                getOptionLabel={(option) => option.sensorName || ''}
                                getOptionSelected={(option, value) => option && value ? option.sensorid === value.sensorid : ''}
                                value={selectedOutsideAirSensors}
                                onChange={(event, value) => handleChangeOutsideAirSensors(event, value)}
                                size="small"
                                renderTags={(value, getTagProps) => value.map((option, index) => {
                                    if (index < 2) {
                                        return (
                                            <Chip
                                                classes={{
                                                    root: classes.Chip
                                                }}
                                                variant="outlined"
                                                label={option.sensorName}
                                                {...getTagProps({ index })}
                                            />
                                        );
                                    } else if (index === 2) {
                                        return (<span className={classes.Tag}>{` + ${value.length - 2} Selected`}</span>);
                                    } else {
                                        return null;
                                    }
                                })}
                                renderOption={(option, { selected }) => (
                                    <React.Fragment>
                                        <Checkbox
                                            value={option.sensorid}
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {renderCheckboxLabel(option)}
                                    </React.Fragment>
                                )}
                                required
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        className={classes.Required}
                                        label="Outside Air Sensors"
                                        error={Boolean(outsideAirSensorData)}
                                        helperText={outsideAirSensorData}
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <React.Fragment>
                                                    {params.InputProps.endAdornment}
                                                </React.Fragment>
                                            ),
                                        }}
                                    />}
                            />
                        </FormControl>
                    </div>
            }
        </div>
    );
};

const mapStateToProps = state => ({
    bobLoading:      state.bob.bobLoading,
    entityRules:     state.reporting.entityRules,
    entityRulesMeta: state.reporting.entityRulesMeta,
    entitySensors:   state.reporting.entitySensors
});

export default connect(mapStateToProps, null)(ConfigurePanel);
